import React from 'react';

interface LoyaltyCardProps {
  title: string;
  icon: JSX.Element;
  onClick: () => void;
}

const LoyaltyCard: React.FC<LoyaltyCardProps> = ({ title, icon, onClick }) => {
  return (
    <div
      className="flex flex-col items-center justify-center p-4 bg-white w-[155px] h-[155px] mobile:w-[128px] mobile:h-[128px] shadow-md rounded-lg cursor-pointer hover:shadow-lg transition-shadow duration-300"
      onClick={onClick}
    >
      {icon}
      <p className="mt-2 text-gray-700 mobile:text-sm">{title}</p>
    </div>
  );
};

export default LoyaltyCard;
